import store from '../store'
import actions from '../store/actions'

export const updateDocument = async (data) => {
  await store.dispatch(actions.callApi, {
    url: `documents/${data.id}`,
    method: 'put',
    body: {
      id: data.id,
      name: data.name,
      description: data.description,
      url: data.url,
      creationDate: data.creationDate
    }
  })
  store.dispatch(actions.createMessage, { text: 'Document updated', color: 'success' })
}

export const deleteDocument = async (data) => {
  await store.dispatch(actions.callApi, {
    url: `documents/${data.id}`,
    method: 'delete'
  })
  store.dispatch(actions.createMessage, { text: 'Document deleted', color: 'success' })
}
